<template>
    <div
        :class="
            'w-90 d-flex flex-row justify-center align-center chapter-content pa-3 mx-3 border-radius-0 mb-2 chapter-text ' +
            typeClass
        "
    >
        <div class="w-90 d-flex flex-column justify-start align-start" @click="setPage" :data-cy="`HighlightItem-${value}-serialized-container`">
            <span class="primary--text d-inline-block text-truncate" style="max-width: 90%">{{
                marker_data.serialized
            }}</span>
            <span class="text-body-2 text-left">{{ info }}</span>
        </div>
        <v-btn :data-cy="`HighlightItem-${value}-delete-button`" icon small color="primary" :loading="loading" dark @click="deleteHighlight"
            ><v-icon dark class="primary--text">mdi-delete</v-icon></v-btn
        >
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

import HighlightService from '@/services/highlight'

export default {
    props: {
        marker_data: { type: Object, default: null },
        value: Number
    },
    data() {
        return {
            loading: false,
        }
    },
    computed: {
        ...mapState({
            currentStage: (state) => state.bookReading.currentStage,
            currentPage: (state) => state.bookReading.currentPage,
            currentChapter: (state) => state.bookReading.currentChapter,
            currentChapterData: (state) => state.bookReading.currentChapterData,
            bookHighlightData: (state) => state.bookReading.bookHighlightData,
        }),
        info() {
            return `${this.$t('bookReading.located_in')}: ${this.$t('bookReading.chapter')} ${
                this.marker_data.chapter.chapterNumber
            }, ${this.$t('bookReading.page')} ${this.marker_data.page}`
        },
        typeClass() {
            switch (this.marker_data.ordinalHighlightType) {
                case 0:
                    return 'bg-characters'
                case 1:
                    return 'bg-actions'
                case 2:
                    return 'bg-vocabulary'
                case 3:
                    return 'bg-places'
                default:
                    return ''
            }
        },
    },
    methods: {
        ...mapActions('bookReading', [
            'setCurrentPage',
            'setCurrentChapter',
            'setCurrentChapterData',
            'hideAllUtils',
            'spliceHighlight',
            'setHighlightData',
        ]),
        setPage() {
            window.scrollTo(0, 0)
            let bookPage = document.querySelector(`#bookpage_${this.currentPage}`)
            if (bookPage) bookPage.style.display = 'none'

            let chapterHtml = document.querySelector(`#chapter_${this.currentChapter}`)
            if (chapterHtml) chapterHtml.style.display = 'none'

            this.setCurrentChapter(this.marker_data.chapter.chapterNumber)
            this.setCurrentPage(this.marker_data.page)

            chapterHtml = document.querySelector(`#chapter_${this.currentChapter}`)
            if (chapterHtml) chapterHtml.style.display = 'block'

            const currentPage = document.querySelector(`.current-page`)
            if(currentPage) currentPage.classList.toggle('current-page')

            bookPage = document.querySelector(`#bookpage_${this.currentPage}`)
            if (bookPage) {
                bookPage.style.display = 'flex'
                bookPage.classList.toggle('current-page')
            }

            this.setCurrentChapterData(this.marker_data.chapter)
            this.hideAllUtils()
        },
        deleteHighlight() {
            const tokenSplitter = "\n";
            this.loading = !this.loading
            this.$highlight.delete(
                this.marker_data.id,
                `#bookpage_${this.currentPage}`,
                this.setHighlighType(this.marker_data.ordinalHighlightType),
                this.marker_data.serialized.split(tokenSplitter)
            )
            this.spliceHighlight(this.marker_data)
            HighlightService.delete(this.marker_data.id)
                .then((response) => {
                    this.setHighlightData(response.content.highlight)
                })
                .catch((error) => console.error(error))
            this.hideAllUtils()
        },
        setHighlighType(type) {
            switch (type) {
                case 0:
                    return 'characters'
                case 1:
                    return 'actions'
                case 2:
                    return 'vocabulary'
                case 3:
                    return 'places'
                default:
                    return ''
            }
        },
    },
}
</script>

<style>
.chapter-content {
    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)) !important;
    transition: background-image 0.5s ease;
}
.chapter-content:hover {
    cursor: pointer;
    background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)) !important;
    border-radius: 2px;
}
.chapter-text {
    border: 1.5px solid #514773 !important;
    background: white;
    color: #514773;
}

.chapter-active {
    border: 1.5px solid #514773 !important;
    background: #514773 !important;
    color: white !important;
}

.bg-vocabulary {
    background: #ffe367;
}
.bg-characters {
    background: #b6ea8f;
}
.bg-actions {
    background: #96dfec;
}
.bg-places {
    background: #ff93d7;
}
</style>
